import API from 'common/API'
import { LanguageType, ThemeType } from 'constants/Config'
import { Movie } from 'models/Movie'
import { User } from 'models/User'

type InitializeData = {
    movie: Movie
    theme: ThemeType
    language: LanguageType
}

/**
 * superviserからinitをたたいてデータを取得します
 */
export const init: () => Promise<InitializeData> = async () => {
    if (window === undefined || !(window as any).OR) {
        throw Error()
    }
    const response = await new Promise(resolve => {
        (window as any).OR.Extension.onInitialize((payload: any) => {
            resolve(payload)
        });
        (window as any).OR.Extension.ready()
    });
    return toInitializedData(response)
}

type InitializeConfigData = {
    theme: ThemeType
    language: LanguageType
}

/**
 * 設定画面用の初期化
 */
 export const initConfig: () => Promise<InitializeConfigData> = async () => {
    if (window === undefined || !(window as any).OR) {
        throw Error()
    }
    const response = await new Promise(resolve => {
        (window as any).OR.Extension.onConfigInitialize((payload: any) => {
            resolve(payload)
        });
        (window as any).OR.Extension.ready()
    });
    return toInitializedConfigData(response)
}

type AuthorizedData = {
    error?: string
    uuid?: string
    accessToken?: string
}

/**
 * supervisorから認証を行う
 */
export const authorize: () => Promise<AuthorizedData> = async () => {
    if (window === undefined || !(window as any).OR) {
        throw Error()
    }
    const response = await new Promise(resolve => {
        (window as any).OR.Extension.onAuthorize((payload: any) => {
            resolve(payload)
        });
        (window as any).OR.Extension.requestAuthentication()
    });
    const data = toAuthorizedData(response)
    if (!data.error && data.uuid && data.accessToken) {
        API.init(data.uuid, data.accessToken)
    }
    return data
}

/**
 * 画面遷移をする
 */
export const transition: (url: string) => void = (url) => {
    if (window === undefined || !(window as any).OR) {
        throw Error()
    }
    (window as any).OR.Extension.requestTransition(url)
}

const toInitializedData: (response: any) => InitializeData = (response) => {
    const movie = toMovie(response.movie)
    const theme = toThemeType(response.theme)
    const language = toLanguageType(response.language)
    return {
        movie: movie,
        theme: theme,
        language: language
    }
}

const toInitializedConfigData: (response: any) => InitializeConfigData = (response) => {
    const theme = toThemeType(response.theme)
    const language = toLanguageType(response.language)
    return {
        theme: theme,
        language: language
    }
}

const toThemeType: (response: any) => ThemeType = (response) => {
    return response === 'dark' ? ThemeType.Dark : ThemeType.Light
}

const toLanguageType: (response: any) => LanguageType = (response) => {
    switch(response) {
        case 'en': return LanguageType.En
        case 'ko': return LanguageType.Ko
        case 'zh': return LanguageType.Zh
        default: return LanguageType.Ja
    }
}

const toAuthorizedData: (response: any) => AuthorizedData = (response) => {
    return {
        error: response.error,
        uuid: response.uuid,
        accessToken: response.accessToken
    }
}

const toMovie: (response: any) => Movie = (response) => {
    const params = {
        id: response.id,
        user: toUser(response.user)
    }
    return new Movie(params)
}

const toUser: (response: any) => User = (response) => {
    const params = {
        id: response.id
    }
    return User.of(params)
}
